export enum LayoutType {
  Default = 1,
  Simple = 2
}
